import { render, staticRenderFns } from "./MainCart.vue?vue&type=template&id=4e44b260&scoped=true&"
import script from "./MainCart.vue?vue&type=script&lang=ts&"
export * from "./MainCart.vue?vue&type=script&lang=ts&"
import style0 from "./MainCart.vue?vue&type=style&index=0&id=4e44b260&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e44b260",
  null
  
)

export default component.exports